import { createTheme } from '@material-ui/core/styles';

const solstice = {
  // CF https://www.figma.com/file/XcS1SdVJAtrkloDi3P4iu73u/Fundation%2FColors?node-id=236%3A8
  branding: {
    brand: '#01579B'
  },
  component: {
    emphasized: '#2962FF',
    border: '1px solid #E0E0E0',
    backgroundHeader: '#F5F5F5',
    errorMain: '#f44336',
    errorLight: '#FFEBEE'
  },
  text: {
    baseText: '#424242',
    secondary: '#757575',
    tertiary: '#9E9E9E',
    disabled: '#757575'
  },
  typography: {
    fontSize: 14
  },
  spacing: {
    unit: 8
  }
};

export const SolsticeTheme = createTheme({
  sidebar: {
    width: 272, // The default value is 240
    closedWidth: 48 // The default value is 55
  },
  palette: {
    contrastThreshold: 3,
    tonalOffset: 0.2,
    primary: {
      main: solstice.component.emphasized // Primary color used for main button
    },
    secondary: {
      main: solstice.branding.brand //Main dark blue color for solstice (top bar)
    },
    error: {
      main: solstice.component.errorMain,
      light: solstice.component.errorLight
    }
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ['"Segoe UI"', 'Arial', 'sans-serif'].join(','),
    fontSize: 14
  },
  text: {
    primary: solstice.text.baseText,
    secondary: solstice.text.secondary,
    disabled: solstice.text.disabled,
    hint: solstice.text.tertiary
  },
  shape: {
    borderRadius: 2
  },
  shadows: [
    //Remove all shadows
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none'
  ],
  overrides: {
    MuiList: {
      root: {
        'background-color': 'white',
        '& .new-filter-item': { minWidth: '170px' }
      }
    },
    MuiListItemText: {
      inset: {
        '&:first-child': {
          paddingLeft: '33px'
        },
        paddingLeft: '33px'
      }
    },
    MuiSnackbarContent: {
      root: {
        color: '#424242'
      }
    },
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        borderRadius: '2px'
      },
      label: {
        'padding-right': '6.5px'
      }
    },
    MuiIconButton: {
      root: {
        width: '28px',
        height: '28px', //Reduce the height of the Icon button
        padding: '0px'
      }
    },
    MuiSwitch: {
      icon: {
        border: solstice.component.border
      },
      iconChecked: {
        'border-color': solstice.branding.brand
      }
    },
    MuiCheckbox: {
      root: {}
    },
    PrivateSwitchBase: {
      root: {
        padding: 'inherit'
      }
    },
    MuiTab: {
      root: {
        'text-transform': 'none'
      },
      wrapper: {
        'font-size': solstice.typography.fontSize + '!important' //Force the font size here, would be good to have a more targeted CSS rule instead of important
      }
    },
    MuiTable: {
      root: {
        border: solstice.component.border,
        'background-color': 'white'
      }
    },
    MuiTableRow: {
      head: {
        height: '30px'
      },
      root: {
        height: '30px'
      }
    },
    MuiTableSortLabel: {
      root: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },
    MuiTableCell: {
      body: {
        padding: '0 8px !important',
        maxWidth: '20vw',
        wordBreak: 'break-word'
      },
      head: {
        padding: '0 8px !important',
        color: solstice.text.secondary,
        'background-color': `${solstice.component.backgroundHeader} !important`,
        height: '30px',
        border: solstice.component.border,
        'font-size': solstice.typography.fontSize
      }
    },
    MuiTablePagination: {
      input: {
        border: 'none',
        'background-color': 'transparent'
      },
      select: {
        paddingTop: '7px',
        'font-size': solstice.typography.fontSize
      },
      selectRoot: {
        'margin-right': '0'
      }
    },
    MuiDrawer: {
      docked: {
        'background-color': 'white',
        'border-right': solstice.component.border,
        overflow: 'hidden'
      }
    },
    MuiPaper: {
      root: {
        // Adds sticky bulk action toolbar when it opened
        "&[class*='bulkActionsDisplayed'] [class*='RaBulkActionsToolbar']": {
          top: '0px',
          position: 'sticky'
        },
        // Adds sticky header cell on table when the bulk action toolbar is opened
        "&[class*='bulkActionsDisplayed'] [class*='RaDatagrid-headerCell']": {
          top: '62px',
          position: 'sticky'
        },
        // Disables sticky header cell on sub-children when the bulk action toolbar is opened
        "&[class*='bulkActionsDisplayed'] .show-page [class*='RaDatagrid-headerCell']": {
          top: 'initial',
          position: 'static',
          zIndex: 'initial'
        }
      },
      elevation0: {
        height: 'inherit!important',
        marginTop: '0px !important'
      },
      elevation1: {
        'background-color': 'transparent' // Used as background of edit and list
      },
      elevation2: {
        // Used for autocomplete menu
        'background-color': 'white',
        border: solstice.component.border
      },
      elevation8: {
        'box-shadow':
          '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
      }
    },
    MuiPopover: {
      paper: {
        border: '1px solid #E0E0E0'
      }
    },
    MuiAutocomplete: {
      input: {
        padding: '5px 5px 6px !important'
      },
      popper: {
        backgroundColor: 'white',
        border: '1px solid #E0E0E0',
        'box-shadow':
          '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
      }
    },
    MuiInput: {
      root: {
        border: solstice.component.border,
        'border-radius': '2px',
        'background-color': 'white',
        minHeight: '30px'
      },
      input: {
        padding: '5px 5px 6px',
        'font-size': solstice.typography.fontSize
      },
      underline: {
        'border-bottom': solstice.component.border,
        '&:before': {
          borderBottom: 'none',
          'border-bottom-width': '1px!important' //Always reduce the size of the bottom border of hover on a field
        }
      }
    },
    MuiInputBase: {
      input: {
        height: 'inherit'
      }
    },
    MuiInputLabel: {
      root: {
        'z-index': '1',
        'margin-left': '1px',
        color: solstice.text.secondary,
        fontSize: '14px'
      },
      formControl: {
        transform: 'none',
        'font-size': solstice.typography.fontSize,
        'line-height': '20px',
        top: '-8px'
      },
      shrink: {
        transform: 'none'
      },
      marginDense: {
        transform: 'none'
      }
    },
    MuiFormControl: {
      marginNormal: {
        'margin-top': '-20px',
        'margin-bottom': '0px'
      },
      root: {
        width: '100%'
      }
    },
    MuiListItemIcon: {
      root: {
        'font-size': '20px',
        'margin-right': '0px',
        'padding-right': '1.2em'
      }
    },
    MuiSvgIcon: {
      root: {
        'font-size': '20px'
      }
    },
    MuiSelect: {
      icon: {
        top: 'inherit'
      }
    },
    MuiTypography: {
      caption: {
        'font-size': solstice.typography.fontSize
      },
      h5: {
        'line-height': '24px',
        'font-size': '18px',
        'padding-top': '16px',
        'font-weight': '500'
      },
      colorTextSecondary: {
        color: 'rgba(0, 0, 0, 0.75)'
      },
      h6: {
        fontSize: '18px'
      },
      body1: {
        'font-size': '14px'
      }
    },
    AutocompleteInput: {
      suggestionsContainerOpen: {
        'background-color': 'red'
      }
    },
    MuiDialog: {
      paperWidthFalse: {
        maxWidth: 'calc(100% - 32px) !important'
      },
      paperScrollPaper: {
        maxHeight: 'calc(100% - 32px) !important'
      },
      paper: {
        margin: '16px !important',
        '&[aria-labelledby=alert-dialog-title]': {
          '& div:nth-of-type(1)': {
            border: 0,
            paddingBottom: '7px'
          },
          '& div:nth-of-type(2)': {
            paddingTop: '7px',
            paddingBottom: '20px',
            backgroundColor: '#ffffff'
          },
          '& div:nth-of-type(3)': {
            'flex-direction': 'row-reverse',
            'justify-content': 'flex-start',
            border: 0,
            paddingTop: '20px',
            paddingBottom: '14.5px',
            '& button': {
              lineHeight: '14px',
              '& svg': { display: 'none' },
              '& span': { padding: 0 }
            },
            '& button:nth-of-type(1)': {
              border: '1px solid #E0E0E0',
              color: solstice.component.emphasized,
              margin: '0px 4px 0px 4px',
              padding: '6px 16px'
            },
            '& button:nth-of-type(2)': {
              border: '1px solid #2962FF',
              backgroundColor: '#2962FF',
              color: '#ffffff',
              margin: '0px 4px 0px 4px',
              padding: '6px 16px'
            }
          }
        }
      }
    },
    // Add white backgroundColor to Mui Dialog
    MuiDialogTitle: {
      root: {
        backgroundColor: 'white',
        padding: solstice.spacing.unit * 2,
        borderBottom: solstice.component.border
      }
    },
    MuiDialogContent: {
      root: {
        backgroundColor: '#FAFAFA',
        padding: solstice.spacing.unit * 2,
        '& .simple-form': {
          display: 'flex',
          flex: 1,
          height: '100%',
          width: '100%',
          '& > div': {
            width: '100%',
            // Override MuiCardContent inside SimpleForm
            padding: '0px !important',
            '& > div': {
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }
          }
        }
      }
    },
    MuiDialogActions: {
      root: {
        backgroundColor: 'white',
        margin: '0',
        padding: '8px 12px',
        borderTop: solstice.component.border,
        justifyContent: 'flex-end'
      }
    },
    MuiDialogContentText: {
      root: {
        marginBottom: '0'
      }
    },
    MuiMenu: {
      paper: {
        maxHeight: 'calc(50% - 32px)',
        maxWidth: '50%'
      }
    },
    MuiMenuItem: {
      root: {
        'line-height': '1.4em',
        fontSize: solstice.typography.fontSize,
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingTop: '6px',
        paddingBottom: '6px',
        '&$selected': {
          backgroundColor: '#E3F2FD !important'
        }
      }
    },
    MuiStepIcon: {
      root: {
        width: '24px',
        height: '24px',
        color: '#757575'
      },
      text: {
        fontSize: '0.75rem' //It has to be that time to properly fit in the circle
      },
      completed: {
        color: '#00A645!important'
      }
    },
    MuiStepLabel: {
      iconContainer: {
        paddingRight: '4px'
      },
      label: {
        fontSize: '14px'
      }
    },
    MuiStepConnector: {
      root: {
        minWidth: '32px'
      }
    },
    MuiAvatar: {
      root: {
        margin: '8px'
      }
    },
    MuiTabs: {
      indicator: {
        height: '3px' // Selected Tab underline thickness
      }
    },
    MuiFormGroup: {
      row: {
        marginLeft: '9px',
        marginTop: '12px',
        '& label': {
          marginRight: '35px'
        }
      }
    },
    RaListToolbar: {
      toolbar: {
        alignItems: 'inherit'
      }
    },
    RaNullableBooleanInput: {
      input: {
        width: '100%'
      }
    },
    RaFilter: {
      form: {
        marginTop: 0,
        minHeight: '64px',
        '& > div': {
          alignItems: 'center',
          '& .select': {
            width: '100%'
          },
          '& .hide-filter': {
            marginTop: '17px'
          }
        }
      },
      button: {
        border: '1px solid',
        borderColor: '#E0E0E0',
        borderRadius: '2px',
        backgroundColor: 'white',
        marginTop: '8px',
        minHeight: '28px',
        width: '170px',
        '& svg': { display: 'none' },
        '& button': { paddingTop: '2px', fontSize: '14px' }
      }
    },
    RaAutocompleteArrayInput: {
      container: {
        '& > div > label': {
          marginTop: '8px',
          fontSize: '16px',
          '& > span:before': {
            zIndex: 10,
            top: 8,
            left: 430,
            position: 'absolute',
            height: 0,
            width: 0,
            display: 'inline-block',
            borderTop: '5px solid #757575',
            borderRight: '5px solid transparent',
            borderLeft: '5px solid transparent',
            content: '" "'
          }
        },
        '& > div > div:before ': { borderBottom: 'none' }
      },
      suggestionsContainer: {
        backgroundColor: '#FFF',
        border: '1px solid #E0E0E0'
      },
      chip: {
        color: '#212121',
        fontSize: '12px',
        textDecoration: 'none',
        boxSizing: 'border-box',
        backgroundColor: '#F5F5F5 !important',
        border: '1px solid #E0E0E0',
        borderRadius: '2px',
        padding: '0 5px',
        marginLeft: 0,
        height: '23px',
        '& > span': {
          paddingLeft: 0
        },
        '& > svg': {
          width: '17px',
          height: '17px'
        }
      },
      chipContainerFilled: {
        margin: '5px'
      },
      inputRootFilled: {
        backgroundColor: '#FFF !important',
        border: '1px solid #E0E0E0',
        fontSize: '14px',
        padding: 0,
        transition: 'all .3s ease',
        '&:hover': {
          backgroundColor: '#FFF'
        }
      },
      inputInput: { padding: '5px 0px' }
    },
    RaSimpleFormIterator: {
      line: {
        borderBottom: 'none',
        '& .ra-input > div': {
          marginTop: 0,
          width: '100%'
        }
      },
      indexContainer: {
        color: '#757575',
        paddingTop: '5px'
      },
      action: {
        paddingTop: 0
      }
    }
  }
});
